import { render, staticRenderFns } from "./giftAddress.vue?vue&type=template&id=3922f3be&scoped=true&"
import script from "./giftAddress.vue?vue&type=script&lang=js&"
export * from "./giftAddress.vue?vue&type=script&lang=js&"
import style0 from "./giftAddress.vue?vue&type=style&index=0&id=3922f3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3922f3be",
  null
  
)

export default component.exports